import { render, staticRenderFns } from "./PlayHub.vue?vue&type=template&id=d0afc18e&scoped=true"
import script from "./PlayHub.vue?vue&type=script&lang=js"
export * from "./PlayHub.vue?vue&type=script&lang=js"
import style0 from "./PlayHub.vue?vue&type=style&index=0&id=d0afc18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0afc18e",
  null
  
)

export default component.exports